import React, { useEffect } from 'react'
import styles from './AppliedCouponView.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCircleCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

const AppliedCouponView = ({couponDetails, setModalOpen}) => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll
    });
  }, [])

  const closeModal= () => {
    setModalOpen(false)
  }

  return (
    <div className={styles.appliedCoupon}>
        
        <FontAwesomeIcon className={styles.badge} icon={faCircleCheck}/>
        <button className={styles.close} onClick={closeModal}><FontAwesomeIcon icon={faXmark} /></button>
        <div className={styles.container}>
            <p className={styles.gray}>{couponDetails?.couponcode} applied</p>

            <div style={{display: "flex" , flexDirection: "column", gap: "1rem"}}>
            <p className={styles.savingsText}>{couponDetails?.description}</p>

            {/* <p className={styles.gray}>Lorem ipsum, dolor sit amet consectetur adipisicing.</p> */}
            <p className={styles.gray}>Woohoo! Your coupon is successfully applied</p>
            </div>

            <p className={styles.yay} onClick={() => setModalOpen(false)}>YAY!</p>
        </div>
    </div>
  )
}

export default AppliedCouponView